// extracted by mini-css-extract-plugin
export default {"rating":"rz-z","numberOfStars":"sz-z","count":"tz-z","barGraphSpacing":"uz-z","barGraph":"vz-z"};